class SimplePriceController {
    constructor(currencyFilter) {
        this.currencyFilter = currencyFilter;
    }

    $onInit() {
        this.buildDisplayPrice(this.price);
    }

    $onChanges(change) {
        this.buildDisplayPrice(change.price.currentValue);
    }

    buildDisplayPrice(price) {
        if (price === undefined) { return; }

        const displayPrice = this.currencyFilter(price);

        this.currencySymbol = displayPrice.slice(0, 1);
        [this.priceDollar, this.priceCents] = displayPrice.slice(1).split('.');
    }
}

const simplePriceControllerComponentDefinition = {
    bindings: {
        price: '<',
        priceClassModifier: '@?',
    },
    controller: ['currencyFilter', SimplePriceController],
    template: `
        <div class="simplePrice" ng-class="::$ctrl.priceClassModifier">
            <span class="simplePrice-dollars">{{ ::$ctrl.currencySymbol }}{{ $ctrl.priceDollar }}.{{ $ctrl.priceCents }}</span>
        </div>
    `,
};

module.exports = {
    SimplePriceController,
    simplePriceControllerComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/simpleprice/simple-price.component.js